import Vue from "vue";
import Prompt from "./app/Prompt.vue";

import { isMobile } from "utils/utils";
import { MessageBox } from "element-ui";

const mobilePrompt = params => {
  let instance;
  if (instance) return;
  return new Promise(resolve => {
    let instance;
    const MessageBoxConstructor = Vue.extend({
      components: { Prompt },
      render(h) {
        const props = {
          ...params,
          show: this.show,
          getValue: vaule => {
            resolve(vaule);
          },
          remove: () => {
            document.body.removeChild(instance.$el); //从body中移除dom
            instance.$destroy();
            instance = null;
          }
        };
        return h(Prompt, { props });
      },
      data() {
        return {
          show: true
        };
      }
    });
    instance = new MessageBoxConstructor().$mount(
      document.createElement("div")
    );
    document.body.appendChild(instance.$el);
  });
};

function prompt() {
  if (!isMobile()) {
    return MessageBox.prompt;
  }
  if (isMobile()) {
    return mobilePrompt;
  }
}

export default prompt();
